import { create } from "zustand";

export const useControlStore = create((set) => ({
  controls: [],
  loading: false,
  error: null,
  selectedControl: null,
  searchQuery: "",
  filters: {},
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  columnFilters: {},
  uniqueValues: {},
  sortBy: "scf_id",
  sortOrder: "asc",
  scopeStandards: [],
  categoryDomains: [],
  catalogSeedTagsFilter: [],
  scopeOptions: [],
  categoryOptions: [],
  scopeLoading: false,

  setControls: (controls) => set({ controls }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setPagination: (pagination) => set({ pagination }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setScopeOptions: (scopeOptions) => set({ scopeOptions }),
  setCategoryOptions: (categoryOptions) => set({ categoryOptions }),
  setScopeLoading: (scopeLoading) => set({ scopeLoading }),

  setSort: (sortBy, sortOrder) => set({ sortBy, sortOrder }),
  setScopeStandards: (scopeStandards) =>
    set({ scopeStandards: Array.isArray(scopeStandards) ? scopeStandards : [] }),
  setCategoryDomains: (categoryDomains) =>
    set({ categoryDomains: Array.isArray(categoryDomains) ? categoryDomains : [] }),
  setCatalogSeedTagsFilter: (catalogSeedTagsFilter) =>
    set({
      catalogSeedTagsFilter: Array.isArray(catalogSeedTagsFilter) ? catalogSeedTagsFilter : [],
    }),

  setSearchQuery: (query) => set({ searchQuery: query }),
  setFilters: (newFilters) =>
    set((state) => ({ filters: { ...state.filters, ...newFilters } })),
  setSelectedControl: (control) => set({ selectedControl: control }),
  clearError: () => set({ error: null }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
}));
